import React, { useState } from 'react';
import Title from 'antd/es/typography/Title';
import { RefContextLanguage } from '../providers/LanguageProvider';

import * as libCon from "../community-hats-js-library/Constants.js"
// import * as locCon from "../LocalConstants.js"

import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions.js';
import { LoadingParticipants } from '../components/LoadingDatasets';
import FileSplitter from '../components/FileSplitter.js';
import UploadLabResults from '../components/UploadLabResults.js';
import MatchLabResults from '../components/MatchLabResults.js';
import ExportMappedLabReports from '../components/ExportMappedLabReports.js';
import { RefStoredValue } from '../hooks/GeneralStoreHooks.js';





function DashboardUploadLabResults() {
  const i18n = RefContextLanguage();



    const participantStatus = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANTS)


    const [pdfFiles, setPdfFiles] = useState(null);
    const [metadataForFiles, setMetadataForFiles] = useState(null)
    const [mappingDict, setMappingDict] = useState({})





    return (
        <div className="mainContainer" >
            <Title level={1}>{i18n.t('labUploads')}</Title>



            {/* File Splitter */}
            <FileSplitter />

            {
                participantStatus !== libCon.OK
                    ? <LoadingParticipants />
                    : <div className="mainContainer">
                        {/* Upload Results */}
                        <UploadLabResults pdfFiles={pdfFiles}
                            setPdfFiles={setPdfFiles}
                            metadataForFiles={metadataForFiles}
                            setMetadataForFiles={setMetadataForFiles}
                            resetUploadProgress={() => {
                                setMappingDict({})
                                setMetadataForFiles(null)
                            }
                            } />
                        {/* Match Results */}
                        {
                            isNullOrUndefined(metadataForFiles)
                                ? <div />
                                : <MatchLabResults
                                    metadataForFiles={metadataForFiles}
                                    mappingDict={mappingDict}
                                    setMappingDict={setMappingDict}
                                />
                        }
                        {/* Export Results */}
                        {
                            isNullOrUndefined(mappingDict) || Object.keys(mappingDict).length === 0
                                ? <div />
                                : <ExportMappedLabReports
                                    pdfFiles={pdfFiles}
                                    metadataForFiles={metadataForFiles}
                                    mappingDict={mappingDict}
                                />
                        }


                    </div>
            }


        </div>
    )
}

export default DashboardUploadLabResults